import React from 'react';
import Roller from '../assets/roller.svg';
import Shopify from '../assets/shopify.svg';
import Settings from '../assets/settings.svg';
import Analytics from '../assets/analytics.svg';

export default () => {
  return (
    <div className="mb-16 pt-8">
      <div className="container text-center mt-8 mb-8 md:mb-10">
        <h2 className="leading-none md:leading-normal font-sans text-shop-dark-green text-4xl">
          Features
        </h2>
      </div>
      <div className="container flex flex-row flex-wrap text-center md:text-left">
        <div className="w-full md:w-1/2 mb-8">
          <div className="flex-row flex flex-wrap">
            <div className="w-full md:w-1/4 content-center justify-center flex">
              <Shopify className="self-center mb-8 sm:mb-0" />
            </div>
            <div className="w-full md:w-3/4 pr-6">
              <h2 className="leading-normal font-sans text-shop-dark-green text-2xl">
                Built For Shopify
              </h2>
              <p className="leading-normal font-sans text-shop-dark-green mt-4">
                Focused on Shopify to bring you the best experience for your
                store
                <br />
                Looks and feels just like the rest of your Shopify Admin, no
                confusing stuff here!
              </p>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 mb-8">
          <div className="flex-row flex flex-wrap">
            <div className="w-full md:w-1/4 content-center justify-center flex">
              <Roller className="self-center mb-8 sm:mb-0" />
            </div>
            <div className="w-full md:w-3/4 pr-6">
              <h2 className="leading-normal font-sans text-shop-dark-green text-2xl">
                Customizable Responsive Emails
              </h2>
              <p className="leading-normal font-sans text-shop-dark-green mt-4">
                Change colors
                <br />
                Upload your logo
                <br />
                Customize the Thank You copy depending on the customers score
              </p>
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2 mb-8">
          <div className="flex-row flex flex-wrap">
            <div className="w-full md:w-1/4 content-center justify-center flex">
              <Settings className="self-center mb-8 sm:mb-0" />
            </div>
            <div className="w-full md:w-3/4 pr-6">
              <h2 className="leading-normal font-sans text-shop-dark-green text-2xl">
                Automatic
              </h2>
              <p className="leading-normal font-sans text-shop-dark-green mt-4">
                Surveys are sent out automatically X (customizable) days after a
                customer makes a purchase.
                <br />
                Survey throttling prevents customers from being over surveyed.
              </p>
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2 ">
          <div className="flex-row flex flex-wrap">
            <div className="w-full md:w-1/4 content-center justify-center flex">
              <Analytics className="self-center mb-8 sm:mb-0" />
            </div>
            <div className="w-full md:w-3/4 pr-6">
              <h2 className="leading-normal font-sans text-shop-dark-green text-2xl">
                Collect Feedback
              </h2>
              <p className="leading-normal font-sans text-shop-dark-green mt-4">
                Learn what your customers think of your shop, brand, products
                and more.
                <br />
                Take action, and work to improve your NPS score and create
                happier customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
